module.exports = __webpack_public_path__ + "media/images/iconLockOpen__accent--dark-ad5bf1835fee7c4016c57276eea8b546.png";